// extracted by mini-css-extract-plugin
export default {"projectEfficiencyContainer":"styles_projectEfficiencyContainer__EQoJ8","dark":"styles_dark__So8-u","breakLine":"styles_breakLine__wReCn"};